import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import getImageUrl from '../../utils/getImageUrl';

export class CardImageHolder extends Component {
  constructor(props) {
    super();

    this.calculateSize = this.calculateSize.bind(this);
    this.state = {
      containerWidth: 520,
      containerHeight: 520,
    };
  }

  componentDidMount() {
    this.calculateSize();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.calculateSize);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.calculateSize)
    }
  }

  calculateSize() {
    const { image, isVertical, cardWidth, cardHeigth } = this.props;
    const container = findDOMNode(this.refs.containers).parentNode;
    const containerRect = container.getBoundingClientRect();
    if (image.isGif()) {
      this.setState({
        containerWidth: cardWidth ? cardWidth : containerRect.width,
        containerHeight: cardHeigth ? cardHeigth : containerRect.width
      });
    } else {
      this.setState({
        containerWidth: cardWidth ? cardWidth : containerRect.width,
        containerHeight: isVertical ? 'auto' : containerRect.width
      });
    }
  }

  renderBlurredGif() {
    const { image, noFrame } = this.props;
    const { containerWidth, containerHeight } = this.state;
    const isVertical = (image.height > image.width);

    const width = isVertical ? 'auto' : '100%';
    const height = isVertical ? '100%' : 'auto';

    const backgroundStyle = {
      width: containerWidth,
      height: containerHeight,
      position: 'relative',
      display: 'block',
      textAlign: 'center',
      overflow: 'hidden',
      verticalAlign: 'middle',
      backgroundColor: image.get('avg'),
      zIndex: -10
    };

    const blurStyle = {
      background: `url(${image.get('largeUrl')}) no-repeat`,
      position: 'absolute',
      width: '100%', // 520,
      height: '100%', // 520,
      backgroundSize: '100% 100%',
      filter: 'blur(10px)',
      WebkitFilter: 'blur(10px)',
      MozFilter: 'blur(10px)',
      OFilter: 'blur(10px)',
      top: '-15px',
      right: '-15px',
      bottom: '-15px',
      left: '-15px',
      zIndex: '-10',
    };

    const dimmedStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgb(0,0,0)',
      opacity: 0.5,
      zIndex: -9,
      filter: 'alpha(opacity=50)',
    };

    return (
      <div style={backgroundStyle} ref="containers">
        <span className="bg_blur" style={blurStyle}></span>
        <span className="frame_dimmed" style={dimmedStyle}></span>
        <img src={getImageUrl(image.get('url'))} className="img_thumb" alt=""
          ref="image"
          style={{ 
            position: 'absolute',
            width, height,
            maxWidth: '100%', 
            maxHeight: '100%', 
            top: '50%',
            left: '50%',
            display: 'block',
            transform: 'translate(-50%, -50%)',
            marginRight: '-50%',
          }} 
        />
        { !noFrame && <span className="frame_g"></span> }
        <span className="txt_gif">GIF</span>
      </div>
    );
  }

  render() {
    const { image, width, height, isVertical, maxWidth, cardHeight, noFrame, noGifBlur } = this.props;
    const { containerWidth, containerHeight } = this.state;
    const ratio = image.get('width') / image.get('height');

    if (image.isGif() && !noGifBlur) {
      return this.renderBlurredGif();
    }

    const backgroundStyle = {
      width: containerWidth,
      height: cardHeight ? cardHeight : containerHeight,
      position: 'relative',
      maxWidth, 
      maxHeight: containerWidth * 4,
      overflow: 'hidden',
      textAlign: 'center',
      verticalAlign: 'middle',
      backgroundColor: image.get('avg'),
      zIndex: -10
    };

    return (
      <div style={backgroundStyle} ref="containers">
        <img src={getImageUrl(image.get('largeUrl') || image.get('url'))}
          className="img_thumb" alt="" 
          style={!isVertical ? {
            position: 'absolute',
            margin: 'auto',
            width: ratio > 1.0 ? 'auto' : '100%',
            height: ratio > 1.0 ? '100%' : 'auto',

            minWidth: '100%',
            minHeight: '100%',

            left: '-1000%',
            right: '-1000%',
            top: '-1000%',
            bottom: '-1000%'
          } : {
            width: '100%',
            height: 'auto',
          }}
        />
        { image.isGif() && noGifBlur && <span className="txt_gif">GIF</span> }
        { !noFrame && <span className="frame_g"></span> }
      </div>
    );
  }
}

export default CardImageHolder;



// WEBPACK FOOTER //
// ./src/components/CardImageHolder/index.js